export default "__VITE_PUBLIC_ASSET__3110f657__"